import { useState } from "react";
import image from "../../images/logo.png";
import axios from "axios";
import URL from "../config/API";
import { Link, useNavigate } from "react-router-dom";

function Register() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const registerSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(`${URL.BASE_URL}/users`, form, {
        headers: { "Content-Type": "application/json" },
      });

      alert("Registration successful");
      navigate("/"); // redirect to login
    } catch (error) {
      alert(error?.response?.data?.message || "Registration failed");
    }
  };

  return (
    <section className="user-form-part">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-10 col-md-12 col-lg-12 col-xl-10">

            {/* Logo */}
            <div className="user-form-logo">
              <Link to="/">
                <img src={image} alt="logo" />
              </Link>
            </div>

            {/* Card */}
            <div className="user-form-card">
              <div className="user-form-title">
                <h2>Create Account</h2>
                <p>Use your details to register</p>
              </div>

              <div className="user-form-group">
                <form className="user-form" onSubmit={registerSubmit}>

                  <div className="form-group">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Enter your name"
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Enter your email"
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="password"
                      name="password"
                      className="form-control"
                      placeholder="Enter your password"
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-button">
                    <button type="submit">Register</button>
                  </div>
                </form>
              </div>
            </div>

            {/* Footer */}
            <div className="user-form-remind">
              <p>
                Already have an account? <Link to="/">Login</Link>
              </p>
            </div>

            <div className="user-form-footer">
              <p>
                Greeny | &COPY; Copyright by{" "}
                <a href="#">Mironcoder</a>
              </p>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default Register;
